// admin/src/context/RecycleBinContext.jsx
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://tripsie.in/api';

const RecycleBinContext = createContext({ count: 0, refreshCount: () => {} });

export const useRecycleBin = () => useContext(RecycleBinContext);

export const RecycleBinProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const refreshCount = useCallback(async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return;
    try {
      const [bRes, rRes] = await Promise.all([
        fetch(`${API_BASE_URL}/bookings/admin/recycle-bin`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_BASE_URL}/reviews/admin/recycle-bin/all`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      const [bData, rData] = await Promise.all([bRes.json(), rRes.json()]);
      const bCount = bData.success ? (Array.isArray(bData.bookings) ? bData.bookings.length : 0) : 0;
      const rCount = rData.success ? (Array.isArray(rData.reviews) ? rData.reviews.length : 0) : 0;
      setCount(bCount + rCount);
    } catch {}
  }, []);

  useEffect(() => { refreshCount(); }, [refreshCount]);

  return (
    <RecycleBinContext.Provider value={{ count, refreshCount }}>
      {children}
    </RecycleBinContext.Provider>
  );
};

